// extracted by mini-css-extract-plugin
export default {"cls1":"Nnkq73dNqAppOIEz49Oz","cls2":"lHyRqPIXzBEBNjrQYhZ5 Nnkq73dNqAppOIEz49Oz"};